<template>
    <div class="subscription-details-container flex-column d-flex">
        <span class="details-header">
        Subscription Details
        </span>
        <div class="details-content flex-column d-flex">
            <div class="details-wrapper justify-content-between d-flex align-items-center w-100 gap-16">
                <span class="details-name truncate truncate--1">Monthly Subscription fee</span>
                <span class="details-amount">{{ $box.formatMoney5(info.subscriptionPrice) }}</span>
            </div>

            <div v-if="info.subscriptionDisplay" class="details-wrapper justify-content-between d-flex align-items-center w-100 gap-16">
                <span class="details-name truncate truncate--2">Discount {{ `(${info.subscriptionDisplay})` }}</span>
                <span class="details-amount">{{ $box.formatMoney5(info.subscriptionDiscount) }}</span>
            </div>

            <div class="details-wrapper justify-content-between d-flex align-items-center w-100 gap-16">
                <span class="details-name truncate truncate--2">10% GST</span>
                <span class="details-amount">{{ $box.formatMoney5(info.subscriptionGst) }}</span>
            </div>

            <div class="separator"></div>

            <div class="details-wrapper justify-content-between d-flex align-items-center w-100 gap-16">
                <span class="details-name truncate truncate--1 font-weight-bold">Total Amount</span>
                <span class="details-amount total">
                    {{ $box.formatMoney5(info.totalPaymentAmount) }}
                </span>
            </div>

        </div>
    </div>
</template>

<style lang="scss" scoped>
@import 'static/scss/colors';
    .subscription-details-container {
        min-height: 210px;
        max-width: 450px;
        width: 100%; 
        border-radius: 5px;
        background-color: $black2;
        margin: 0 auto 2rem;
        padding: 24px;
        font-family: 'Montserrat', sans-serif;
        gap: 1rem;
        color: var(--text-color);
        .details-header {
        font-size: 20px;
        font-weight: 700;
        }

        .details-content {
            gap: 12px;
        }

        .separator {
            padding-bottom: 1px;
            border-bottom: 1px solid $gray8;
        }

        .details-name {
            max-width: 230px;
        }

        .details-amount {
            text-wrap: nowrap;
            &.total {
            font-size: 20px;
            font-weight: 700;
            }
        }
    }
</style>

<script>
export default {
    data() {
        return {

        }
    },

    props: {
        info: {
            default: {
                subscriptionPrice: 0.00,
                subscriptionDisplay: null,
                subscriptionDiscount: 0.00,
                subscriptionGst: 0,
                totalPaymentAmount: 0
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/card/subscription.vue